export default __webpack_public_path__ + "static/media/pic6.2aac7a46.jpg";